export const percentByFlatPrice = 0.3;
